// TODO: Temporarily use auto-render reports
// /* eslint-disable */
// import { Loading, getResources } from 'react-admin';
// import React, { useMemo } from 'react';
// import { useSelector } from 'react-redux';
// import PlayersReportFilters from './components/PlayersReportFilters';
// import ReportLayout from '../../base/components/reports/ReportLayout';
// import PlayersReportResults from './components/PlayersReportResults';
// import { REPORT_TYPES } from '../../constant/resource-slug';

// export const LIST_REPORTS = [REPORT_TYPES.OVERALL, REPORT_TYPES.PREPAID, REPORT_TYPES.STANDARD];

// function ReportPlayersList({ resource }) {
//   const originalResources = useSelector(getResources);

//   const resources = useMemo(() => originalResources, [originalResources?.length]);

//   if (!resources?.length) {
//     return null;
//   }

//   const currentResource = resources.filter((r) => r.name === resource)?.[0];
//   if (!currentResource) {
//     return <Loading />;
//   }

//   const {
//     options: { reportInterface },
//   } = currentResource;

//   return (
//     <ReportLayout
//       totalTables={LIST_REPORTS.length}
//       filterChildren={<PlayersReportFilters reportServiceVersion={reportInterface?.serviceVersion} />}
//       resultChildren={<PlayersReportResults />}
//     />
//   );
// }

// export default ReportPlayersList;

// TODO: Remove the below code when apply 3-table result report
import React, { useMemo } from 'react';
import moment from 'moment';
import WealthListGuesser from '../../base/components/guesser/wealth-list.guesser';
import ReportPlayersLink from './components/report-players.link';
import { useAuthUser } from '../../base/hooks';
import { FILTER_PREFIX_ON_VALUE, isUserSA, SERVER_DATETIME_FORMAT } from '../../constant';
import { REPORT_TYPES } from '../../constant/resource-slug';

export const LIST_REPORTS = [REPORT_TYPES.OVERALL, REPORT_TYPES.PREPAID, REPORT_TYPES.STANDARD];

function ReportPlayersList(props) {
  const user = useAuthUser();

  const filterDefaultValues = useMemo(() => {
    const today = moment()
      .add(1, 'days')
      .startOf('day').format(SERVER_DATETIME_FORMAT);
    const yesterday = moment().subtract(1, 'days').startOf('day').format(SERVER_DATETIME_FORMAT);

    return {
      created: `${FILTER_PREFIX_ON_VALUE.BETWEEN}${yesterday},${today}`,
    };
  }, []);

  return (
    <WealthListGuesser
      {...props}
      extraActions={<ReportPlayersLink />}
      defaultRefFilter={
        isUserSA(user)
          ? {
            group: true,
          }
          : {}
      }
      filterDefaultValues={filterDefaultValues}
    />
  );
}

export default ReportPlayersList;
